<template>
  <nav>
    <v-card height="715" flat color="rgba(0,0,0,0)" style="border-radius: 10px;" class="">
      <v-card class="card1 ml-3 mr-3 mt-2">
        <v-carousel height="270" hide-delimiters :cycle="false" interval="0">
          <v-carousel-item v-for="(item,i) in photos" :key="i" :src="item"></v-carousel-item>
        </v-carousel>
      </v-card>
      <v-card class="card2 pl-3 pr-3 pb-3">
        
          <center>
            <div style="padding-top: 255px; font-size: 18px;">
              <span class="headline green--text stopflow">{{item_name}}</span>
              <v-divider class="ma-2" />
              <span>Price Marked: </span>
              <span class="green--text font-weight-bold">&#8377;{{marked_price}}</span>
							<br/>
							<span>Category: </span>
							<span class="green--text font-weight-bold">{{category}}</span>
            </div>
          </center>
        </v-card>
      </v-card>
    
  </nav>
</template>

<script>
export default {
  props : {
    category : String,
    marked_price : Number,
    item_name : String,
    photos : Array,
  },
  data() {
    return {
    };
  }
};
</script>

<style scoped>
.card1 {
  border-radius: 10px;
  position: relative;
  z-index: 1;
  top: 0px;
}
.card2 {
  border-radius: 10px;
  position: relative;
  bottom: 240px;
  z-index: 0;
}
.card3 {
  border-radius: 0px 0px 10px 10px;
  z-index: 0;
}
.scroll {
  overflow-y: auto;
}
.stopflow {
  display: inline-block;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
}
</style>